<template>
  <div class="sufee-login d-flex align-content-center flex-wrap">
    <div class="container">
      <div class="login-content">
        <div class="login-logo">
          <!-- <a href="index.html">
                        <img class="align-content" src="images/logo.png" alt="">
                    </a> -->
          <img class="align-content" src="images/logo.png" alt="" />
        </div>
        <div class="login-form">
          <form>
            <!-- <div class="form-group">
                            <label>소속법인</label>
                            <b-form-select name="groupCode" v-validate="'required'" v-model="vendors" :options="options" @change="__change($event)"></b-form-select>
                            <span v-show="errors.has('groupCode')" class="c_red p-5-10">* 소속법인을 선택해주세요({{ errors.first('groupCode') }})</span>
                        </div> -->
            <div class="form-group">
              <label>아이디</label>
              <input
                name="loginId"
                type="text"
                class="form-control"
                placeholder="아이디"
                v-model="loginData.loginId"
                v-validate="'required|max:30'"
                data-vv-delay="500"
                @keyup.enter="login"
              />
              <span v-show="errors.has('loginId')" class="c_red p-5-10"
                >* 아이디를 입력해주세요({{ errors.first("loginId") }})</span
              >
            </div>
            <div class="form-group">
              <label>비밀번호</label>
              <input
                name="passwd"
                type="password"
                class="form-control"
                placeholder="비밀번호"
                v-model="loginData.passwd"
                v-validate="'required|max:20'"
                data-vv-delay="500"
                @keyup.enter="login"
              />
              <span v-show="errors.has('passwd')" class="c_red p-5-10"
                >* 비밀번호를 입력해주세요({{ errors.first("passwd") }})</span
              >
            </div>
            <button
              type="button"
              v-on:click="login"
              class="btn btn-success btn-flat m-b-30 m-t-30"
            >
              로그인
            </button>
            <div class="register-link m-t-15 text-center"></div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ResultMessage from "../data/resultMessage";
import * as type from "@/store/mutation-types";

export default {
  name: "Login",
  data() {
    return {
      loginData: {
        loginId: "",
        passwd: "",
        vendors: ""
      },
      options: [
        { value: null, text: "소속법인을 선택해주세요." },
        {
          value: {
            callVendor: type.callVendor.BYULDAERI,
            saleVendor: type.saleVendor.BYULDAERI
          },
          text: "별대리"
        },
        {
          value: {
            callVendor: type.callVendor.CHUNG_BANG,
            saleVendor: type.saleVendor.CHUNG_BANG
          },
          text: "청방"
        },
        {
          value: {
            callVendor: type.callVendor.BYULDAERI,
            saleVendor: type.saleVendor.KIA
          },
          text: "KDELIVERY"
        }
      ],
      vendors: null
    };
  },
  computed: {
    ...mapGetters({
      userAccount: "userAccount/userAccount"
    })
  },
  watch: {},
  mounted: function() {
    let cs = this;
    window.csLogin = function(id, pw) {
      const csLoginData = {
        loginId: id,
        passwd: pw,
        vendors: ""
      };
      let resultMessage = new ResultMessage();
      cs.$store
        .dispatch("userAccount/login", csLoginData)
        .then(() => {
          //   cs.$router.push("/monitoring");
          cs.$router.push("/v2/monitoring");
        })
        .catch(error => {
          resultMessage.buildErrorMessage(error);
          alert(resultMessage.message);
        });
    };
  },
  methods: {
    login: function() {
      this.$validator.validateAll().then(success => {
        if (success == false) {
          alert("필수 항목을 모두 입력해주세요");
          return;
        }
        let resultMessage = new ResultMessage();
        this.$store
          .dispatch("userAccount/login", this.loginData)
          .then(() => {
            // this.$router.push('/monitoring');
            this.$router.push("/v2/monitoring");
          })
          .catch(error => {
            resultMessage.buildErrorMessage(error);
            alert(resultMessage.message);
          });
      });
    },
    __change: function(value) {
      // console.debug('__change : ' + JSON.stringify(value))
      // return this.loginData.vendors = JSON.stringify(value)
      console.debug("__change : " + value);
      return (this.loginData.vendors = value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue